import { Flex, styled } from '@grupoboticario/flora-react';

export default {
  Wrapper: styled('div', {
    paddingBottom: 'calc($4 + 80px)',
    display: 'block',
    height: '100%',
    width: '100%',
    position: 'relative',
  }),
  ContentWrapper: styled(Flex, {
    padding: '$4',
    flexDirection: 'column',
    height: '100%',
    overflowX: 'hidden',
    position: 'relative',
  }),
  Reseller: styled('div', {
    position: 'fixed',
    bottom: '0',
    left: '0',
    width: '100%',
    padding: '$4',
    backgroundColor: '$light-light',
    boxShadow: '$upSoft',
    textAlign: 'center',

    '@tablet': {
      position: 'absolute',
    },
  }),
};
